<template>
  <div class="">
    <i
      class="fa-li fa fa-ellipsis-v dropbtn"
      @click="(event) => dropdownOption(event)"
    ></i>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
    window.onclick = (event) => {
      if (!event.target.matches(".dropbtn")) {
        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains("show")) {
            openDropdown.classList.remove("show");
          }
        }
      }
    };
  },
  methods: {
    dropdownOption(event) {
      this.$eventHub.$emit("companyRetainershipData", this.data);
    },
  },
};
</script>